import { useTranslation } from "@next-platform/client-common-core";
import { ButtonIcon, ButtonSize, ButtonVariant, IconVariants, Shape, Text } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

interface IImageGalleryHeaderProps {
  totalImages: number;
  currentImageIndex: number;
  onNavigatePrev: () => void;
  onNavigateNext: () => void;
}

export const ImageGalleryHeader = ({ totalImages, currentImageIndex, onNavigatePrev, onNavigateNext }: IImageGalleryHeaderProps) => {
  const { t } = useTranslation();
  return (
    <div data-testid="ImageGalleryHeader" className="flex items-center justify-between">
      {totalImages > 0 ? (
        <Text className="ml-[2px] font-normal text-white">
          <Trans i18nKey="common:modal.generateAvatar.gallery.draftsNotice" count={totalImages} />
        </Text>
      ) : null}
      {totalImages > 1 && (
        <div className="flex gap-sm items-center">
          <ButtonIcon
            icon={IconVariants.CHEVRON_LEFT}
            size={ButtonSize.SMALL}
            shape={Shape.SQUARE}
            variant={ButtonVariant.OUTLINED}
            onClick={onNavigatePrev}
            disabled={currentImageIndex <= 0}
            className="w-8"
            aria-label={t("common:modal.generateAvatar.ariaLabel.previousImage")}
          />
          <Text className="font-normal text-white">{`${currentImageIndex + 1}/${totalImages}`}</Text>
          <ButtonIcon
            icon={IconVariants.CHEVRON_RIGHT}
            size={ButtonSize.SMALL}
            shape={Shape.SQUARE}
            variant={ButtonVariant.OUTLINED}
            onClick={onNavigateNext}
            disabled={currentImageIndex >= totalImages - 1}
            className="w-8"
            aria-label={t("common:modal.generateAvatar.ariaLabel.nextImage")}
          />
        </div>
      )}
    </div>
  );
};
